import React from "react";
import PropTypes from "prop-types";

const delay = (ms) => new Promise((res) => setTimeout(res, ms));

class RedirectAuthenticate extends React.Component {
  logRedirect(url) {
    const logs = JSON.parse(localStorage.getItem("redirectLogs") || "[]");
    logs.push({ url, timestamp: new Date().toISOString() });
    localStorage.setItem("redirectLogs", JSON.stringify(logs));
  }

  async redirect() {
    await delay(1000);
    this.logRedirect(this.props.urlRedirect);
    window.location.replace(this.props.urlRedirect);
  }

  componentDidMount() {
    if (this.props.urlRedirect) {
      this.redirect();
    }
  }

  render() {
    return (
      <div className="row justify-content-center">
        <div className="col-12 d-grid">
          <main className="position-relative">
            <div className="loading-bar-container ">
              <div className=" loading-bar-container loading-bar" />
            </div>
            <h5 className="position-absolute start-50 translate-middle mt-4">Redirecionando, aguarde...</h5>
          </main>
        </div>
      </div>
    );
  }
}

RedirectAuthenticate.propTypes = {
  urlRedirect: PropTypes.string,
};

export default RedirectAuthenticate;
